module.exports = __webpack_public_path__ + "static/media/fi.307e59aa.webp";